export default __webpack_public_path__ + "static/media/mexico.90f9f41e.png";